import { Fragment, useState } from "react";
import SimpleProfitAndLossTable from "../components/SimpleProfitAndLossTable";
import Select from "react-select";
import DetailedProfitAndLossTable from "../components/DetailedProfitAndLossTable";

const ProfitAndLoss = () => {
  const [viewMode, setViewMode] = useState(null);

  const handleViewModeChange = (selectedOption) => {
    if (selectedOption) {
      setViewMode(selectedOption.value);
    } else {
      setViewMode(null);
    }
  };

  return (
    <Fragment>
      <h1>Profit And Loss</h1>
      <div className="m-3">
        <label htmlFor="viewMode">View Mode:</label>
        <Select
          value={
            viewMode
              ? {
                  value: viewMode,
                  label:
                    viewMode === "simple" ? "Simple View" : "Detailed View",
                }
              : null
          }
          options={[
            { value: "simple", label: "Simple View" },
            { value: "detailed", label: "Detailed View" },
          ]}
          onChange={handleViewModeChange}
          placeholder="Select view mode"
          isClearable
        />
      </div>

      {viewMode && (
        <div className="table-responsive m-3">
          {viewMode === "simple" ? (
            <SimpleProfitAndLossTable />
          ) : (
            <DetailedProfitAndLossTable />
          )}
        </div>
      )}
    </Fragment>
  );
};

export default ProfitAndLoss;
